export function calculateScaledOffset(ref, baseOffset = -24) {
  if (!process.browser || !ref) return 0;

  try {
    const layout = document.querySelector('.autoscale');
    const layoutStyle = getComputedStyle(layout);
    const layoutTransform = layoutStyle.transform;

    if (layoutTransform === 'none') return -92;

    const firstIndex = layoutTransform.indexOf('(') + 1;
    const secondIndex = layoutTransform.indexOf(',');

    const layoutScale = +layoutTransform.substring(firstIndex, secondIndex);

    const element = ref?.$el || ref;
    const elementOffsetTop = element.offsetTop;
    const elementScaledOffset = elementOffsetTop * layoutScale;

    const scaledOffset = elementScaledOffset - elementOffsetTop + baseOffset;
    return scaledOffset;
  } catch (e) {
    console.error(e);
    return 0;
  }
}
